import styled, { css } from 'styled-components';
import { detailValues } from './types';

interface ScreeningDetailsLayoutProps {
  scrollableBody?: boolean;
}

export const ScreeningDetailsComponent = styled.section<ScreeningDetailsLayoutProps>`
  padding: ${({ theme }) => theme.pxToRem(30)};
  width: 100%;

  ${({ scrollableBody }) =>
    scrollableBody &&
    css`
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 0;
      overflow: hidden;
    `}
`;

export const ScreeningDetailsData = styled.div<ScreeningDetailsLayoutProps>`
  margin-bottom: ${({ theme }) => theme.pxToRem(10)};

  ${({ scrollableBody, theme }) =>
    scrollableBody &&
    css`
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      padding-right: ${theme.pxToRem(8)};
    `}
`;

export const Heading = styled.div`
  color: ${({ theme }) => theme.colours.crowberryBlue};
  font-size: ${({ theme }) => theme.pxToRem(24)};
  line-height: ${({ theme }) => theme.pxToRem(30)};
  padding-bottom: ${({ theme }) => theme.pxToRem(30)};
  border-bottom: 1px solid ${({ theme }) => theme.colours.gallery};
`;

export const Subheading = styled.div`
  color: ${({ theme }) => theme.colours.charcoalDust};
  font-size: ${({ theme }) => theme.pxToRem(14)};
  line-height: ${({ theme }) => theme.pxToRem(21)};
  font-weight: 600;
  padding: ${({ theme }) => theme.pxToRem(10)} 0;
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.colours.charcoalDust};
  font-size: ${({ theme }) => theme.pxToRem(14)};
  line-height: ${({ theme }) => theme.pxToRem(21)};
`;
export const Value = styled.span<detailValues>`
  color: ${({ theme }) => theme.colours.crowberryBlue};
  font-size: ${({ theme }) => theme.pxToRem(14)};
  line-height: ${({ theme }) => theme.pxToRem(21)};
  ${({ lineBreaks }) => lineBreaks && 'white-space: pre;'}
`;

export const Detail = styled.div`
  padding-bottom: ${({ theme }) => theme.pxToRem(10)};

  &:last-of-type {
    border-bottom: 1px solid ${({ theme }) => theme.colours.gallery};
    margin-bottom: ${({ theme }) => theme.pxToRem(30)};
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.pxToRem(20)};
  flex-shrink: 0;
`;
